import { CdkScrollableModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { CoreContentModule } from "@obg/ngx.core.content";
import { CompactFooterModule } from "@obg/ngx.ui.core";

import { MatNavbarModule } from "../navbar/navbar.module";
import { OverlaySpinnerModule } from "../overlay-spinner/overlay-spinner.module";

import { DialogLayoutComponent } from "./dialog-layout.component";
import { IframeDialogLayoutComponent } from "./iframe-dialog-layout/iframe-dialog-layout.component";

const DIRECTIVES: any[] = [DialogLayoutComponent, IframeDialogLayoutComponent];

const MAT_MODULES: any[] = [MatButtonModule, MatDialogModule];

@NgModule({
	imports: [
		CommonModule,
		CoreContentModule,
		MAT_MODULES,
		CompactFooterModule,
		OverlaySpinnerModule,
		MatNavbarModule,
		CdkScrollableModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class DialogLayoutModule {}
